import { ImmerReactiveVar } from './makeImmerVar';
import { ImmerReactiveVarWithPatches } from './makeImmerVarWithPatches';

const makeReactiveVarManager = () => {
  const vars = [] as (
    | ImmerReactiveVar<any>
    | ImmerReactiveVarWithPatches<any>
  )[];
  const reset = () => {
    vars.forEach((v) => {
      v.reset();
    });
  };
  const add = (v: ImmerReactiveVar<any> | ImmerReactiveVarWithPatches<any>) => {
    vars.push(v);
  };
  return {
    reset,
    add,
  };
};

export const ReactiveVarManager = makeReactiveVarManager();
